import { render, staticRenderFns } from "./ConfirmYourFeatures.vue?vue&type=template&id=f513b306&scoped=true&"
import script from "./ConfirmYourFeatures.vue?vue&type=script&lang=ts&"
export * from "./ConfirmYourFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmYourFeatures.vue?vue&type=style&index=0&id=f513b306&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513b306",
  null
  
)

export default component.exports